interface Props { tool?: string; size?: number }

// Mirrors TOOL_LABEL in shared/src/constants.ts. Kept inline here because
// Vite's CJS interop with the workspace shared package doesn't reliably
// surface named exports — switch to the shared import once shared ships
// an ESM bundle.
const LABELS: Record<string, string> = {
  chatgpt: "ChatGPT",
  claude: "Claude",
  gemini: "Gemini",
  copilot: "Copilot",
  other: "Other",
};

export function ToolBadge({ tool = "other", size = 14 }: Props) {
  return (
    <span className="sg-tool-badge" title={LABELS[tool] ?? tool}>
      <ToolIcon tool={tool} size={size} />
      <span>{LABELS[tool] ?? tool}</span>
    </span>
  );
}

export function ToolIcon({ tool, size = 14 }: { tool: string; size?: number }) {
  const s = size;
  switch (tool) {
    case "chatgpt":
      return (
        <svg width={s} height={s} viewBox="0 0 24 24" aria-hidden className="sg-tool-icon sg-tool-chatgpt">
          <path d="M21.2 10.5a5.4 5.4 0 0 0-0.5-4.5 5.5 5.5 0 0 0-6-2.6 5.5 5.5 0 0 0-9.3 1.9 5.5 5.5 0 0 0-3.7 2.7 5.5 5.5 0 0 0 0.7 6.5 5.4 5.4 0 0 0 0.5 4.5 5.5 5.5 0 0 0 6 2.6 5.5 5.5 0 0 0 9.3-1.9 5.5 5.5 0 0 0 3.7-2.7 5.5 5.5 0 0 0-0.7-6.5z" fill="currentColor" />
        </svg>
      );
    case "claude":
      return (
        <svg width={s} height={s} viewBox="0 0 24 24" aria-hidden className="sg-tool-icon sg-tool-claude">
          <path d="M7.3 16.5h-2l3.6-9h2.7l3.6 9h-2l-0.8-2.2H8.2l-0.9 2.2zm1.5-3.8h3.5L10.6 8l-1.8 4.7zM19.8 7.5h2v9h-2z" fill="currentColor" />
        </svg>
      );
    case "gemini":
      return (
        <svg width={s} height={s} viewBox="0 0 24 24" aria-hidden className="sg-tool-icon sg-tool-gemini">
          <path d="M12 2l2 7 7 2-7 2-2 7-2-7-7-2 7-2z" fill="currentColor" />
        </svg>
      );
    case "copilot":
      return (
        <svg width={s} height={s} viewBox="0 0 24 24" aria-hidden className="sg-tool-icon sg-tool-copilot">
          <path d="M9.5 4a4 4 0 0 0-3.873 3h-.764A3.863 3.863 0 0 0 1 10.863C1 13.148 2.852 15 5.137 15H6.5a4.5 4.5 0 0 0 4.487-4.13l.013-.37V8.5a4.5 4.5 0 0 0-1-2.83A4 4 0 0 0 9.5 4zm5 4a4 4 0 0 0-3.487 2.04A4.5 4.5 0 0 0 11 8.5v2c0 .126-.005.25-.013.37A4.5 4.5 0 0 0 12 13.5v.137A4.363 4.363 0 0 0 16.363 18H17.5a4 4 0 0 0 3.873-3h.764A3.863 3.863 0 0 0 22 11.137C22 8.852 20.148 7 17.863 7H17.5a4.5 4.5 0 0 0-3 1.13A3.99 3.99 0 0 0 14.5 8z" fill="currentColor" />
        </svg>
      );
    default:
      return (
        <svg width={s} height={s} viewBox="0 0 24 24" aria-hidden className="sg-tool-icon">
          <circle cx="12" cy="12" r="6" fill="none" stroke="currentColor" strokeWidth="1.4" />
        </svg>
      );
  }
}

export function toolLabel(tool: string): string {
  return LABELS[tool] ?? (tool.charAt(0).toUpperCase() + tool.slice(1));
}
